import {ValidationRulesEngine} from 'common-utils';
import {pdsUtils} from './pds-utils';
import {pdsI18n} from './pds-i18n';

let flattenedPdsValidationRulesEngine = pdsUtils.createFlattenedClassInstance(ValidationRulesEngine);
flattenedPdsValidationRulesEngine.setI18n(pdsI18n);

export let pdsValidationRulesEngine = flattenedPdsValidationRulesEngine;
